

































































import { Component, Prop } from 'vue-property-decorator';
import { CreateSurveyElement } from '@/models/Presentation';
import Base from '@/views/Base';
import WInlineEdit from '@/components/WInlineEdit.vue';
import SurveyPreviewResults from '@/views/presentation/components/SurveyPreviewResults.vue';

@Component({
  components: { SurveyPreviewResults, WInlineEdit }
})
export default class SurveyPreview extends Base {
  @Prop() surveyElement!: CreateSurveyElement;
  @Prop({ default: false }) editable!: boolean;
  @Prop({ default: false }) onlyResults!: boolean;
  @Prop() surveyBackgroundUrl!: string | undefined;
  @Prop({ default: false }) large!: boolean;
  @Prop({ default: null }) validations!: any | null;

  currentPage: 'result' | 'vote' = 'vote';

  mounted() {
    this.currentPage = this.onlyResults ? 'result' : 'vote';
  }

  submitted = false;

  currentAnswer = null;
  currentAnswers: number[] = [];

  vote() {
    this.submitted = true;
    setTimeout(() => {
      this.currentPage = 'result';
    }, 3000);
  }

  get backgroundStyle() {
    let style: any = {}
    if (this.surveyBackgroundUrl) {
      style = {
        backgroundImage: `url(${this.surveyBackgroundUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    }

    if(this.editable && this.surveyElement.answers.length > 7){
      style.aspectRatio = '1';
    }else if(this.editable && this.surveyElement.answers.length > 4) {
      style.aspectRatio = '4/3';
    }
    else {
      style.aspectRatio = '16/9';
    }

    return style;
  }

}
